import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const VentureAccountInfoComponent = ({ accounts, onInnerFormChange, selectedVenture }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="PersonAccount"
              name="IsPersonAccount"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event,
                  'Account.IsPersonAccount',
                  selectedVenture?.Account
                )
              }}
              type="checkbox"
              value={selectedVenture?.Account?.IsPersonAccount}
          />
       <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Account.Name',
                  selectedVenture?.Account
                )
              }}
              type="text"
              value={selectedVenture?.Account?.Name}
          />
       
    </div>
 }
 expandedPanel="accountInfo"
 headerTitle="Account Info"
/>
</>
)
export default VentureAccountInfoComponent;
